import { Injectable } from '@angular/core';
import { Client, FeatureFlag } from './client.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';

@Injectable({
  providedIn: 'root'
})

export class FeatureFlagService {
  resultSet: FeatureFlag[] = [];

  constructor(private client: Client,  private snackBar: MatSnackBar) { }

  getFeatures(token: string, featureName: string): Promise<boolean> {
    return this.client.getFeatures(token).toPromise()
      .then(response => {
        if (response) {
          this.resultSet = response;
          return this.isFeatureEnabled(featureName, response);
        }
        return false;
      })
      .catch(error => {
          this.snackBar.openFromComponent(MatSnackBarComponent, {
           data: "The product ECN is currently not enabled in MW Admin Portal- API Adapter service. Please contact support for more information.",
            duration: 10000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
          });
        throw error; 
      });
  }
  

  isFeatureEnabled(featureName: string, resultSet: FeatureFlag[]): boolean{
    const feature = resultSet.find((f: FeatureFlag) => f.featureName === featureName);
    if (!feature?.value) return false;
    
    const currentVersion = this.getCurrentApiVersion();
    const requiredVersion = feature.apiAdapterVersion;
    
    return !currentVersion || !requiredVersion || 
           this.compareVersions(requiredVersion, currentVersion) <= 0;
  }

  private getCurrentApiVersion(): string | null {
    return sessionStorage.getItem('apiAdapterVersion');
  }

  private compareVersions(required: string, current: string): number {
    const requiredParts = required.split('.').map(part => parseInt(part) || 0);
    const currentParts = current.split('.').map(part => parseInt(part) || 0);
    
    const maxLength = Math.max(requiredParts.length, currentParts.length);
    
    for (let i = 0; i < maxLength; i++) {
      const requiredPart = requiredParts[i] || 0;
      const currentPart = currentParts[i] || 0;
      
      if (requiredPart < currentPart) {
        return -1;
      }
      if (requiredPart > currentPart) {
        return 1;
      }
    }
    
    return 0;
  }
}
